<template>
  <div class="h-full max-w-md mx-auto p-8 grid grid-rows-1-auto">
    <div class="text-xl">
      <ul>
        <li>
          <icon name="ArrowRight" />Was ist Stupsi?
        </li>
        <li>
          <icon name="ArrowRight" />Impressum
        </li>
      </ul>
    </div>
    <div class="text-center text-primary-500">
      <icon name="WaldigLogo" size="3.5em" :settings="{strokeWidth: 1, circle: true}" />
    </div>
  </div>
</template>

<script>
const InputText = require("@/modules/input/components/InputText.vue").default;
const InputCheck = require("@/modules/input/components/InputCheck.vue").default;
const InputTextarea = require("@/modules/input/components/InputTextarea.vue")
  .default;

export default {
  name: "InfoSite",
  mixins: [],
  data: () => ({
    routes: []
  }),
  components: {},
  computed: {},
  methods: {},
  created() {
    this.$store.dispatch("header/reset");
  }
};
</script>
